import "./index.scss";
import { INTERNAL_PATHS } from "routes/paths";
import { ReactComponent as CheckIcon } from "assets/check-icon.svg";
import { ReactComponent as HeartIcon } from "assets/heart-icon.svg";
import { ReactComponent as ArrowIcon } from "assets/arrow-icon.svg";

export const BrandMoreOnRaise = ({ path, isLoggedIn }) => {
  const options = [
    {
      icon: {
        component: CheckIcon,
        width: "14",
        height: "10",
        alt: "Balance Check icon"
      },
      text: `Check your balance`,
      href: path
        ? INTERNAL_PATHS.GIFT_CARD_BALANCE_CHECK + path
        : INTERNAL_PATHS.GIFT_CARD_BALANCE
    },
    {
      icon: {
        component: HeartIcon,
        width: "15",
        height: "14",
        alt: "Referrals icon"
      },
      text: "Send $5 to a friend",
      href: isLoggedIn
        ? INTERNAL_PATHS.MY_REFERRALS
        : INTERNAL_PATHS.USER_LOG_IN
    }
  ];

  return (
    <div className="brand-more-on-raise" data-testid="brand-more-on-raise">
      <h3>More on Raise</h3>
      <div className="options-list">
        {options.map(({ icon, text, href }) => (
          <a href={href} key={text}>
            <div>
              <icon.component
                width={icon.width}
                height={icon.height}
                alt={icon.alt}
                importance="low"
                decoding="async"
                loading="lazy"
              />
            </div>
            <p>{text}</p>
            <div className="icon">
              <ArrowIcon
                width="6"
                height="11"
                alt="go to"
                importance="low"
                decoding="async"
                loading="lazy"
              />
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};
